import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EnrolledUserItem } from "../types";

interface UseEnrolledUsersListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  fieldFilters?: Record<string, any>;
}

export const ENROLLED_STATUS = "E,C,P,T,X";

export const getEnrolledUsersUrl = (
  corporateId: string | number,
  objectId: number,
) =>
  `${ServicesURL.getEnrollment}?corporateId=${corporateId}&objectId=${objectId}&showIssuedCertificate=true&onlyStandAlone=true`;

export const useEnrolledUsersList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  fieldFilters,
}: UseEnrolledUsersListArgs): PaginatedListResult<EnrolledUserItem> => {
  const url = corporateId ? getEnrolledUsersUrl(corporateId, objectId) : null;

  return usePaginatedList<EnrolledUserItem>(
    url,
    {
      page,
      pageSize,
      search,
      fieldFilters: { status: ENROLLED_STATUS, ...(fieldFilters || {}) },
    },
    {
      responseKey: "enrollmentResponses",
      totalElementsKey: "totalElements",
      totalPagesKey: "totalPages",
    },
  );
};
